var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.666 19.4332V21.8332H37.3327V19.4332C37.3327 17.9397 37.3327 17.193 37.042 16.6225C36.7864 16.1208 36.3784 15.7128 35.8767 15.4572C35.3062 15.1665 34.5595 15.1665 33.066 15.1665H14.9327C13.4392 15.1665 12.6925 15.1665 12.122 15.4572C11.6203 15.7128 11.2123 16.1208 10.9567 16.6225C10.666 17.193 10.666 17.9397 10.666 19.4332Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3327 21.8332H10.666M22.666 27.1665H15.9993M10.666 19.4332L10.666 29.5665C10.666 31.06 10.666 31.8067 10.9567 32.3771C11.2123 32.8789 11.6203 33.2869 12.122 33.5425C12.6925 33.8332 13.4392 33.8332 14.9327 33.8332L33.066 33.8332C34.5595 33.8332 35.3062 33.8332 35.8767 33.5425C36.3784 33.2869 36.7864 32.8789 37.042 32.3771C37.3327 31.8067 37.3327 31.06 37.3327 29.5665V19.4332C37.3327 17.9397 37.3327 17.193 37.042 16.6225C36.7864 16.1208 36.3784 15.7128 35.8767 15.4572C35.3062 15.1665 34.5595 15.1665 33.066 15.1665L14.9327 15.1665C13.4392 15.1665 12.6925 15.1665 12.122 15.4572C11.6203 15.7128 11.2123 16.1208 10.9567 16.6225C10.666 17.193 10.666 17.9397 10.666 19.4332Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card.e560e21837d4c6168109f7c0dfbffc9c.svg";